module.exports = __webpack_public_path__ + "img/i_chat_plus_w.9fbaf1e9.svg";